import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { dayjs } from '../../lib/utils';
import { useAccessToken } from '../useProfile';
import type { WorkoutData } from '../../pages/LogWorkout';

type UseLogWorkoutOptions = {
  onError?: (error: Error) => void;
};

export const useLogWorkout = ({ onError }: UseLogWorkoutOptions = {}) => {
  const queryClient = useQueryClient();
  const accessToken = useAccessToken();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (data: WorkoutData) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/workouts/log`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken.data}`,
          },
          body: JSON.stringify({
            type: data.type,
            distance: data.distance,
            duration: data.duration,
            notes: data.notes,
            date: data.date,
            exercises: data.exercises,
            completedAt: dayjs(data.date).toISOString(),
          }),
        },
      );

      if (!response.ok) throw new Error('Failed to log workout');
      return response.json();
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({ queryKey: ['workouts'] });
      navigate({
        to: '/workouts/$id',
        params: { id: String(data.activity.id) },
        replace: true,
      });
    },
    onError,
  });
};
